// @ts-nocheck
/* eslint-disable */
import Content from './content';

export default class Place extends Content {
	_build() {
		this._dom.container.classList.add("content-place");

		var d;

		if (Array.isArray(this._data)) {
			d = this._data;
		} else {
			d = this._data.value;
		}
		var nodes = [];
		if (this._data.label) {
			nodes.push("<h4>" + this._data.label +"</h4>");
		}
		nodes.push("<ul>");
		for (var i = 0; i < (d || []).length; i++) {
			nodes.push("<li>" + d[i] + "</li>");
		}
		nodes.push("</ul>");
		this._dom.container.innerHTML = nodes.join("");
	}
}
